const faqItems = [
  {
    q: '萝卜影视上的电视剧全集需要付费吗？',
    a: '完全不需要。萝卜影视所有电视剧全集、连续剧完整版和电视剧大结局均免费在线观看，无需注册登录，也不存在任何隐藏收费项目。我们坚持免费开放的理念，让每一位追剧爱好者都能无障碍享受高清电视剧在线全集。',
  },
  {
    q: '电视剧大结局多久会上线？',
    a: '萝卜影视保持每日同步更新的节奏。热门电视剧大结局通常在播出当天就会上线完整版。我们的内容团队会持续追踪最新剧集动态，确保用户在第一时间就能看到电视剧全集，无需漫长等待。',
  },
  {
    q: '播放卡顿或缓冲怎么办？',
    a: '萝卜影视采用多线路智能切换机制，如果当前线路出现缓冲，系统会自动切换至最优线路。建议检查网络连接状态，或尝试切换至较低清晰度。绝大多数情况下，我们的高清播放服务都能保持流畅稳定。',
  },
  {
    q: '支持哪些设备观看电视剧在线全集？',
    a: '萝卜影视完美适配电脑、手机和平板等各类设备。无需下载任何应用，直接在浏览器中访问即可享受高清电视剧全集。无论是在家用电脑大屏追剧，还是通勤路上用手机追剧，体验都很流畅。',
  },
  {
    q: '可以推荐电视剧全集收录吗？',
    a: '当然可以！如果您希望萝卜影视收录某部电视剧全集或连续剧完整版，欢迎通过"联系我们"页面的投稿邮箱与我们联系。请提供剧名和来源平台信息，我们会在评估后尽快安排收录上线。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">
              常见问题
            </h2>
            <p className="text-foreground-400 text-sm max-w-[500px] mx-auto">
              关于萝卜影视电视剧在线全集的常见疑问解答
            </p>
          </div>

          <div className="max-w-[800px] mx-auto flex flex-col gap-3">
            {faqItems.map((item, i) => (
              <details
                key={i}
                className="group bg-background-200/70 rounded-xl border border-background-300/30 overflow-hidden cursor-pointer"
              >
                <summary className="flex items-center justify-between p-5 md:p-6 list-none">
                  <h3 className="text-foreground-100 text-sm md:text-base font-medium pr-4">
                    {item.q}
                  </h3>
                  <div className="w-7 h-7 rounded-full bg-background-300/60 flex items-center justify-center flex-shrink-0 group-open:rotate-45 transition-transform duration-200">
                    <i className="ri-add-line text-foreground-300 text-sm"></i>
                  </div>
                </summary>
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-foreground-400 text-sm leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}